/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { SurveyStatsStatus } from '@features/admin-dashboard/types';
import type { Option } from '@g17eco/molecules/select/types';
import { getPeriodOptions, type DataPeriods } from '@utils/dataPeriods';
import { getMonthOptions, getYearDropdownOptions } from '@utils/date';

export type FilterOptionsMap = {
  initiatives: Option<string>[];
  years: Option<string>[];
  months: Option<string>[];
  periods: Option<DataPeriods>[];
  surveyStatuses: Option<SurveyStatsStatus>[];
};

export const DEFAULT_FILTER_OPTIONS: FilterOptionsMap = {
  initiatives: [],
  months: getMonthOptions().map((option) => ({
    ...option,
    value: option.value.toString(),
    searchString: option.label,
  })),
  years: getYearDropdownOptions(10, 3).map((option) => ({ ...option, value: option.value.toString() })),
  periods: getPeriodOptions().map((option) => ({ ...option, searchString: option.label })),
  surveyStatuses: [
    { value: SurveyStatsStatus.Completed, label: 'Completed', searchString: 'Completed' },
    { value: SurveyStatsStatus.Pending, label: 'Not completed', searchString: 'Not completed' },
  ],
};
